import getTopics from 'services/apiHelpers/getTopics';
import getInteractionsInTopic from 'services/apiHelpers/getInteractionsInTopic';
import { Block } from '@chameleoncreator/creator-app';
import { getTopicsNotHiddenFromNextAndBackNavigation } from 'services/getTopicsNotHiddenFromNextAndBackNavigation';

export const ONLY_TOPICS_NOT_HIDDEN_FROM_NEXT_AND_BACK_NAVIGATION =
  'ONLY_TOPICS_NOT_HIDDEN_FROM_NEXT_AND_BACK_NAVIGATION';

export default (
  onlyTopicsNotHiddenFromNextAndBackNavigation:
    | typeof ONLY_TOPICS_NOT_HIDDEN_FROM_NEXT_AND_BACK_NAVIGATION
    | undefined = undefined
) => {
  let topics = getTopics();

  if (onlyTopicsNotHiddenFromNextAndBackNavigation) {
    topics = getTopicsNotHiddenFromNextAndBackNavigation(topics);
  }

  return topics.reduce((acc: Block[], curr: Block) => {
    return [...acc, ...getInteractionsInTopic(curr).map(i => i?.id)] as Block[];
  }, []);
};
